import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { getFounderType } from '../data/founderTypes';
import TypeIcon from './TypeIcon';

const AvatarRing = styled(motion.div)`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  border-radius: 50%;
  padding: 3px;
  background: ${(props) => props.$color || 'var(--primary-color)'};
  box-shadow: 0 8px 28px ${(props) => `${props.$color || '#2DD4BF'}33`};
  flex-shrink: 0;
`;

const AvatarInner = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: var(--surface-raised);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.$color || 'var(--primary-color)'};
`;

const CodeBadge = styled.span`
  display: inline-block;
  margin-top: 0.5rem;
  padding: 0.25rem 0.65rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  color: ${(props) => props.$color || 'var(--primary-color)'};
  background: ${(props) => `${props.$color || 'var(--primary-color)'}22`};
  border: 1px solid ${(props) => `${props.$color || 'var(--primary-color)'}55`};
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const TypeAvatar = ({
  typeId,
  type: typeProp,
  size = 120,
  showCode = false,
  animate = true,
  className,
}) => {
  const type = typeProp || getFounderType(typeId);
  if (!type) return null;

  const ring = (
    <AvatarRing
      $size={size}
      $color={type.color}
      $colorDark={type.colorDark}
      className={className}
      initial={animate ? { scale: 0.85, opacity: 0 } : false}
      animate={animate ? { scale: 1, opacity: 1 } : false}
      transition={{ type: 'spring', stiffness: 200, damping: 18 }}
      aria-hidden="true"
    >
      <AvatarInner $size={size} $color={type.color}>
        <TypeIcon type={type} size={Math.round(size * 0.42)} color={type.color} />
      </AvatarInner>
    </AvatarRing>
  );

  if (!showCode) return ring;

  return (
    <Wrap>
      {ring}
      <CodeBadge $color={type.color}>{type.code}</CodeBadge>
    </Wrap>
  );
};

export default TypeAvatar;
